export default Object.freeze({
  EN: 'en',
  ES: 'es',
  PT: 'pt',
  IT: 'it',
  FR: 'fr',
  CH: 'ch',
});
